import { Component, OnInit, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { ViewEncapsulation } from "@angular/core";
@Component({
  selector: "app-pop-up",
  templateUrl: "./pop-up-watchlist.component.html",
  styleUrls: ["./pop-up-watchlist.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class PopUpWatchListComponent implements OnInit {
  duplicateData: any;
  docChecks = {
    funds: false,
    itinerary: false,
    hotel: false,
    flight: false,
    isAcknowledged: false,
  };

  get areAllDocsChecked(): boolean {
    return (
      this.docChecks.funds &&
      this.docChecks.itinerary &&
      this.docChecks.hotel &&
      this.docChecks.flight &&
      this.docChecks.isAcknowledged
    );
  }

  constructor(
    private router: Router,
    public dialogRef: MatDialogRef<PopUpWatchListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.duplicateData = data;
  }

  ngOnInit() {
    console.log(this.duplicateData);
  }
  onContinue() {
    // Require all document checkboxes before allowing confirm.
    if (!this.areAllDocsChecked) return;
    this.dialogRef.close("continue");
  }
}
